import React from 'react'

const AreaMenu = (props) => {
  const { insured, setInsured, isHidden, closeAreaMenu, setValue, lang } = props

  const handleOnAreaSelect = (area) => {
    setInsured({ curArea: area })
    setValue('annualArea', `Area ${area}`)
    closeAreaMenu()
  }

  return (
    <div class="desti-menu-wrapper" hidden={isHidden}>
      <div class="desti-menu annual">
        <div class="desti-list-wrapper">
          <div
            class="desti-list"
            onMouseDown={() => {
              handleOnAreaSelect(1)
            }}
          >
            <input
              class="hide-default-radio custom-radio"
              type="radio"
              id="area1"
              name="annual-area"
              value="area1"
              checked={insured.curArea == 1}
            />
            <label class="custom-radio" for="area1">
              <span class="radiomark"></span>
              <span>{lang.destination.area} 1</span>
            </label>
            <table cellpadding="0" cellspacing="0" border="0">
              <tbody>
                <tr>
                  <td>Australia</td>
                  <td>Brunei</td>
                  <td>Cambodia</td>
                </tr>
                <tr>
                  <td>Hong Kong</td>
                  <td>India</td>
                  <td>Indonesia</td>
                </tr>
                <tr>
                  <td>Japan</td>
                  <td>Laos</td>
                  <td>Macau</td>
                </tr>
                <tr>
                  <td>Malaysia</td>
                  <td>Maldives</td>
                  <td>Myanmar</td>
                </tr>
                <tr>
                  <td>New Zealand</td>
                  <td>Pakistan</td>
                  <td>Philippines</td>
                </tr>
                <tr>
                  <td>Singapore</td>
                  <td>South Korea</td>
                  <td>Sri Lanka</td>
                </tr>
                <tr>
                  <td>Taiwan</td>
                  <td>Thailand</td>
                  <td>Vietnam</td>
                </tr>
                <tr>
                  <td colspan="3">
                    China ({lang.destination.excludeTibetMongolia})
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            class="desti-list"
            onMouseDown={() => {
              handleOnAreaSelect(2)
            }}
          >
            <input
              class="hide-default-radio custom-radio"
              type="radio"
              id="area2"
              name="annual-area"
              value="area2"
              checked={insured.curArea === 2}
            />
            <label class="custom-radio" for="area2">
              <span class="radiomark"></span>
              <span>{lang.destination.area} 2</span>
            </label>
            <p dangerouslySetInnerHTML={{ __html: lang.destination.areaDesc2 }}></p>
          </div>
          <div
            class="desti-list"
            onMouseDown={() => {
              handleOnAreaSelect(3)
            }}
          >
            <input
              class="hide-default-radio custom-radio"
              type="radio"
              id="area3"
              name="annual-area"
              value="area3"
              checked={insured.curArea === 3}
            />
            <label class="custom-radio" for="area3">
              <span class="radiomark"></span>
              <span>{lang.destination.area} 3</span>
            </label>
            <p dangerouslySetInnerHTML={{ __html: lang.destination.areaDesc3 }}></p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AreaMenu
